import api from './api';

export const holidayService = {
  getAll: async (year) => {
    const params = year ? `?year=${year}` : '';
    const response = await api.get(`/holidays${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/holidays/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/holidays', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/holidays/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    await api.delete(`/holidays/${id}`);
  },
};
